import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import Box from "@mui/material/Box";

import type { EnumValue } from "@storyboard/dispatch-view/fieldKinds";
import { TestIds } from "@storyboard/web-test-ids/testIds";
import { EnumPill } from "@/components/Dispatch/FieldValue";
import type { DriverRow, TagDefinition } from "@/types/driver";
import type { DriverRouteSummary } from "@/types/driverRoute";
import { ContextCaption, ContextField, ContextText } from "./ContextBlock";
import { NO_VALUE, unitNumber } from "./contextFormat";

/** The pill the field carries when two or more drivers run the truck. */
const TEAM_PILL: EnumValue = { value: "team", label: "Team", color: "purple" };

/**
 * The truck the driver runs: the unit number off the workspace's `Vehicle name` tag as the field's hero value, and a
 * team pill when the route lists two or more drivers.
 */
export default function TruckAssignmentField({
  driver,
  tags,
  route,
}: {
  driver: DriverRow;
  tags: readonly TagDefinition[];
  route: DriverRouteSummary | null;
}) {
  return (
    <ContextField
      icon={<LocalShippingOutlinedIcon sx={{ fontSize: 18 }} />}
      label="Truck Assignment"
      testId={TestIds.dispatch.contextTruckAssignment}
    >
      <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, flexWrap: "wrap" }}>
        <ContextCaption component="span">Unit</ContextCaption>
        <ContextText variant="hero" component="span">
          {unitNumber(driver, tags) ?? NO_VALUE}
        </ContextText>
        {route?.isTeam && (
          <Box component="span" data-sb={TestIds.dispatch.contextTeam} sx={{ alignSelf: "center" }}>
            <EnumPill value={TEAM_PILL.value} known={TEAM_PILL} />
          </Box>
        )}
      </Box>
    </ContextField>
  );
}
